import { jsx } from "react/jsx-runtime";
import CollectionsIcon from "@mui/icons-material/Collections";
import { validateTidalLicense } from "../../base/index.js";
function Collections(props) {
  return /* @__PURE__ */ jsx(
    CollectionsIcon,
    {
      "data-testid": "Collections",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Collections",
      "data-tidal-icon-meta": "devices,photos"
    }
  );
}
Collections.tidalIconMeta = {
  categories: "devices,photos",
  name: "Collections"
};
validateTidalLicense();
export {
  Collections
};
//# sourceMappingURL=Collections.js.map
